import { render, staticRenderFns } from "./AzureComponent.vue?vue&type=template&id=9b1ece66&scoped=true&"
import script from "./AzureComponent.vue?vue&type=script&lang=ts&"
export * from "./AzureComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AzureComponent.vue?vue&type=style&index=0&id=9b1ece66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1ece66",
  null
  
)

export default component.exports